import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as regulationVerifiedState from '../reducers';
import * as regulationVerifiedReducer from '../reducers/regulation-verified.reducer';

export const selectRegulationVerified = createSelector(
  regulationVerifiedState.getRegulationVerifiedState,
  regulationVerifiedReducer.getIsRegulationVerified
);
